import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useStates } from "melco-shared-logic";


type StateListProps = {
  name?: string;
  onChange?: (value: string) => void;
  value?: string;
  selectedCountry?: string;
  mode?: string;
  readOnly?: boolean
  disabled?: boolean
};

export const StatesSelect: React.FC<StateListProps> = ({
  value,
  onChange,
  selectedCountry,

  mode,

  disabled
}) => {

  const { t } = useTranslation();

  const { states } = useStates(selectedCountry ?? "");



  const stateList = (states).map(
    (state) => ({
      value: state.code,
      label: state.name,
    })
  );



  return (

    <Select
      mode={mode === "multiple" ? "multiple" : undefined}
      allowClear
      placeholder={t("global.label.state_code")}
      style={{ width: "100%", minWidth: "150px" }}
      maxTagCount={1}
      options={stateList}
      onChange={onChange}
      value={value}
      disabled={disabled}
      //readonly={disabled}
      showSearch
      optionFilterProp="label"
    />

  );
};
